export default __webpack_public_path__ + "static/media/dynamicFlameReflect.5da8d2b0.jpg";